module.exports = __webpack_public_path__ + "static/media/bigboost.4e8c1f87.png";